import { lazy } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import enums from '../../common/utils/enums';
import { getRegistrationApprovalStatus } from '../../common/utils/approvals';
import * as routePath from '../../common/utils/routePath';
import Loader from '../../views/common/Loader';

const RegisterStep1Page = lazy(() => import('./RegisterStep1Page'));
const RegisterStep2Page = lazy(() => import('./RegisterStep2Page'));
const RegisterStep3Page = lazy(() => import('./RegisterStep3Page'));
const RegisterSuccessPage = lazy(() => import('./RegisterSuccessPage'));
const RegisterPendingPage = lazy(() => import('./RegisterPendingPage'));
const RegisterApprovedPage = lazy(() => import('./RegisterApprovedPage'));
const RegisterPage = lazy(() => import('./RegisterPage'));
const NotFound = lazy(() => import('../../app/views/NotFound'));

const RegisterLayout = () => {
  const location = useLocation();
  const approvalStatus = useSelector((state) =>
    getRegistrationApprovalStatus(state.approvals),
  );

  let redirectTo = null;
  if (approvalStatus === enums.ApprovalStatus.APPROVED) {
    redirectTo = routePath.workOrdersRoute;
  } else if (
    approvalStatus === enums.ApprovalStatus.PENDING &&
    location.pathname !== routePath.registerPendingRoute
  ) {
    redirectTo = routePath.registerPendingRoute;
  }

  if (redirectTo) {
    return (
      <>
        <Navigate to={redirectTo} replace />
        <div className="lazy-loading">
          <Loader size={80} />
        </div>
      </>
    );
  }

  return (
    <RegisterPage>
      <Outlet />
    </RegisterPage>
  );
};

const registerRoutes = [
  {
    path: 'register',
    element: <RegisterLayout />,
    children: [
      { index: true, element: <RegisterStep1Page /> },
      { path: 'step2', element: <RegisterStep2Page /> },
      { path: 'step3', element: <RegisterStep3Page /> },
      { path: 'pending', element: <RegisterPendingPage /> },
      { path: 'success', element: <RegisterSuccessPage /> },
      { path: 'approved', element: <RegisterApprovedPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default registerRoutes;
